<div class="title">
  <p>{{ "COMMON.ASSET_METER_PRICE.SINGLE" | translate }}</p>
  <div class="title-actions">
    <button type="button" class="btn btn-clear-filter" *ngIf="hasActiveFilter" (click)="clearFilters()">
      {{ "COMMON.ASSET_METER_PRICE.CLEAR_FILTER" | translate }}
    </button>
    <select name="filterVendor" class="form-select" [(ngModel)]="filterVendorId" (change)="filter()">
      <option [ngValue]="undefined">
        {{ "COMMON.ASSET_METER_PRICE.VENDOR" | translate }}
      </option>
      <option *ngFor="let vendor of vendors" [ngValue]="vendor.id">
        {{ vendor.name }}
      </option>
    </select>
    <select name="filterMeterMake" class="form-select" [(ngModel)]="filterMeterMakeId" (change)="filter()">
      <option [ngValue]="undefined">
        {{ "COMMON.ASSET_METER_PRICE.METER_MAKE" | translate }}
      </option>
      <option *ngFor="let meterMake of meterMakes" [ngValue]="meterMake.id">
        {{ meterMake.name }}
      </option>
    </select>
    <select name="filterAssetMeterType" class="form-select" [(ngModel)]="filterAssetMeterTypeId" (change)="filter()">
      <option [ngValue]="undefined">
        {{ "COMMON.ASSET_METER_PRICE.ASSET_METER_TYPE" | translate }}
      </option>
      <option *ngFor="let assetMeterType of assetMeterTypes" [ngValue]="assetMeterType.id">
        {{ assetMeterType.name }}
      </option>
    </select>
    <select name="filterStatus" class="form-select" [(ngModel)]="filterStatus" (change)="filter()">
      <option [ngValue]="undefined">
        {{ "COMMON.STATUS" | translate }}
      </option>
      <option *ngFor="let status of statuses" [ngValue]="status.id">
        {{ status.name }}
      </option>
    </select>
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addEditAssetMeterPrice"
      (click)="addNew()" *ngIf="utilityId != 0 && bpsAdminLevel != 2">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
          fill="white" />
      </svg>
      {{ "CRUD_SETTINGS.ADD_NEW" | translate }}
    </button>
  </div>
</div>

<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "COMMON.ASSET_METER_PRICE.ID" | translate }}</th>
      <th>{{ "COMMON.ASSET_METER_PRICE.VENDOR" | translate }}</th>
      <th>{{ "COMMON.ASSET_METER_PRICE.METER_MAKE" | translate }}</th>
      <th>{{ "COMMON.ASSET_METER_PRICE.METER_MODEL" | translate }}</th>
      <th>{{ "COMMON.ASSET_METER_PRICE.ASSET_METER_TYPE" | translate }}</th>
      <th>{{ "COMMON.ASSET_METER_PRICE.METER_PRICE" | translate }}</th>
      <th>{{ "COMMON.STATUS" | translate }}</th>
      <th></th>
    </tr>
    <tr class="content-wrapper" *ngFor="let item of assetMeterPrices" (click)="openEditModal(item)">
      <td>{{ item.name | hasValue }}</td>
      <td>{{ getVendorName(item.organizationId) | hasValue }}</td>
      <td>{{ getMeterMakeName(item.meterBrandId) | hasValue }}</td>
      <td>{{ getMeterModelName(item.meterModelId) | hasValue }}</td>
      <td>{{ getAssetMeterTypeName(item.assetMeterTypeId) | hasValue }}</td>
      <td>{{ item.meterPrice != null ? currency + ' ' + (item.meterPrice | number : '1.2-2') : '----' }}</td>
      <td>{{ getStatusName(item.status) | hasValue }}</td>
      <td class="td-svg">
        <svg data-bs-toggle="modal" data-bs-target="#deleteAssetMeterPrice"
          (click)="onDelete(item); $event.stopPropagation()" width="22" height="22" viewBox="0 0 22 22"
          xmlns="http://www.w3.org/2000/svg" *ngIf="bpsAdminLevel != 2">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B" />
        </svg>
      </td>
    </tr>
  </table>
</div>

<div>
  <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
    (pageChange)="pageChange($event)"></app-paging>
</div>

<button #openEditModalBtn hidden data-bs-toggle="modal" data-bs-target="#addEditAssetMeterPrice"></button>

<div class="modal fade" id="addEditAssetMeterPrice" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ actionLabel$ | async }}
          {{ "COMMON.ASSET_METER_PRICE.SINGLE" | translate }}
        </h5>
        <button type="button" #closeAddEditModal class="btn-cancel-modal" data-bs-dismiss="modal">
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form id="assetMeterPriceForm" class="form-wrapper" ngNativeValidate (submit)="save()">
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input id="assetMeterPriceName" name="assetMeterPriceName" type="text" [(ngModel)]="selectedItem.name"
              class="form-control" required pattern="[a-zA-Z0-9]+" (invalid)="customIdMessage($event)"
              (input)="clearCustomMessage($event)" placeholder=" " />
            <label for="assetMeterPriceName">
              {{ "COMMON.ASSET_METER_PRICE.ID" | translate }}
            </label>
          </div>
          <div class="form-item form-floating mb-3">
            <app-dropdown-search
              id="assetMeterPriceVendor"
              [items]="vendors"
              label="COMMON.ASSET_METER_PRICE.VENDOR"
              [selectedItemId]="selectedItem.organizationId ?? null"
              (selectedIdChange)="onVendorSelected($event)">
            </app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <app-dropdown-search
              id="assetMeterPriceMeterMake"
              [items]="meterMakes"
              label="COMMON.ASSET_METER_PRICE.METER_MAKE"
              [selectedItemId]="selectedItem.meterBrandId ?? null"
              (selectedIdChange)="onMeterMakeSelected($event)">
            </app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <select id="selectMeterModel" name="selectMeterModel" class="form-select selected-option" required
              [disabled]="!selectedItem.meterBrandId" [(ngModel)]="selectedItem.meterModelId">
              <option [ngValue]="undefined" disabled>
                {{ "COMMON.ASSET_METER_PRICE.METER_MODEL" | translate }}
              </option>
              <option *ngFor="let meterModel of meterModelOptions" [ngValue]="meterModel.id">
                {{ meterModel.name }}
              </option>
            </select>
            <label class="label-for-select" for="selectMeterModel">
              {{ "COMMON.ASSET_METER_PRICE.METER_MODEL" | translate }}
            </label>
          </div>
          <div class="form-item form-floating mb-3">
            <select id="selectAssetMeterType" name="selectAssetMeterType" class="form-select selected-option" required
              [(ngModel)]="selectedItem.assetMeterTypeId">
              <option [ngValue]="undefined" disabled>
                {{ "COMMON.ASSET_METER_PRICE.ASSET_METER_TYPE" | translate }}
              </option>
              <option *ngFor="let assetMeterType of assetMeterTypes" [ngValue]="assetMeterType.id">
                {{ assetMeterType.name }}
              </option>
            </select>
            <label class="label-for-select" for="selectAssetMeterType">
              {{ "COMMON.ASSET_METER_PRICE.ASSET_METER_TYPE" | translate }}
            </label>
          </div>
          <div class="form-item form-floating mb-3">
            <input id="assetMeterPriceValue" name="assetMeterPriceValue" type="text" inputmode="decimal"
              [ngModel]="meterPriceDisplay" (input)="onMeterPriceInput($event)"
              class="form-control" required placeholder=" " />
            <label for="assetMeterPriceValue">
              {{ "COMMON.ASSET_METER_PRICE.METER_PRICE" | translate }} ({{ currency }})
            </label>
          </div>
          <div class="form-item form-floating mb-3">
            <select id="selectStatus" name="selectStatus" class="form-select selected-option" required
              [(ngModel)]="selectedItem.status">
              <option [ngValue]="undefined" disabled>
                {{ "COMMON.STATUS" | translate }}
              </option>
              <option *ngFor="let status of statuses" [ngValue]="status.id">
                {{ status.name }}
              </option>
            </select>
            <label class="label-for-select" for="selectStatus">
              {{ "COMMON.STATUS" | translate }}
            </label>
          </div>
        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="assetMeterPriceForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteAssetMeterPrice" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.ASSET_METER_PRICE.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteItem()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button #closeDeleteModal hidden="true" data-bs-dismiss="modal"></button>
      </div>
    </div>
  </div>
</div>
